import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConstant } from 'src/app/app.constant';
import { ToasterService, ToasterType } from 'src/app/services/toaster/toaster.service';
import { Attachment } from 'src/app/_metronic/core/classes/core.class';

@Injectable({
  providedIn: 'root'
})
export class StudentsService {
  apiUrl: string;
  kendoDataUrl: string;

  constructor(private httpClient: HttpClient, private appConstant: AppConstant, private toasterService: ToasterService) {
    this.apiUrl = this.appConstant.getUrl();
    this.kendoDataUrl = this.apiUrl + 'GetAllStudentByInstituteIdKendo';
  }

  manageStudent(student) {
    return this.httpClient.post(`${this.apiUrl}/manageStudent`, student).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  manageStudentAttendance(student) {
    return this.httpClient.post(`${this.apiUrl}/manageStudentAttendance`, student).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  addAttachments(attachments: Attachment[]) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/fileBulkUpload`, attachments).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  uploadProfilePicture(data) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/uploadProfilePicture`, data).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  getNewRollNumber() {
    return this.httpClient.get(`${this.apiUrl}/getNewRollNumber`).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  getAllStudentsByClassIdAndSectionId(branchId: number, classId: number, sectionId: number) {
    return this.httpClient.get(`${this.apiUrl}/studentListByClassAndSection/` + branchId + '/app/' + classId + '/app/' + sectionId).pipe(
      map((response: any) => {
        let data = response.data
        return {
          data: data,
        }
      })
    )
  }
  bulkInsert(StudentData) {
    return this.httpClient.post(`${this.apiUrl}/bulkImportStudent`, StudentData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkUpdate(StudentData) {
    return this.httpClient.post(`${this.apiUrl}/bulkUpdateStudent`, StudentData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  bulkDeleteStudent(studentData) {
    let params = {
      DataToDelete: studentData
    }
    return this.httpClient.post(`${this.apiUrl}/bulkDeleteStudent`, params).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  generateIcard(studentData) {
    return this.httpClient.post(`${this.apiUrl}/generateIcard`, studentData).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  downloadICard(userId) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/downloadIdCardByUser/` + userId, { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 404) {
            this.toasterService.showToaster(null, "No data found.", ToasterType.Error)
          }
          reject(err);
        });
    });
  }

  public downloadStudentCertificate(Id) {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${this.apiUrl}/downloadStudentCertificate/` + Id, { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 403) {
            this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
          }
          reject(err);
        });
    });
  }

  getAllForExcel(state: DataSourceRequestState, customFilters: any) {
    let params = {
      state: state,
      customFilters: customFilters
    }
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/getAllStudent`, params).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  public downloadExcelToUpdateStudent(LocationId: number, BoardId: number, ClassId: number, SectionId: number) {
    return new Promise((resolve, reject) => {
      this.httpClient.post(`${this.apiUrl}/downloadExcelToUpdateStudent`, 
        {
          LocationIds: LocationId,
          BoardId: BoardId,
          ClassId: ClassId,
        }, 
        { responseType: 'blob' }).pipe(
        map(res => res))
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          if (err.status == 400) {
            this.toasterService.showToaster(null, "Please select filters: Location, Board, Class and Section!", ToasterType.Error)
          }
          if (err.status == 422) {
            this.toasterService.showToaster(null, "No data found!", ToasterType.Error)
          }
          reject(err);
        });
    });
  }
  getAll(state: DataSourceRequestState, customFilters: any): Observable<DataResult> {
    let params = {
      state: state,
      customFilters: customFilters
    }
    return this.httpClient.post(`${this.apiUrl}/getAllStudent/`, params).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllStudentName(filters): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllStudentName/`, filters).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  getAllStudentNameIdCard(filters): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllStudentName/`, filters).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllStudentNameIndividualReport(filters) {
    return this.httpClient.post(`${this.apiUrl}/getAllStudentName/`, filters).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  getStudentsToInsertMark(reqData): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getStudentsToInsertMark`, reqData).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }
  public getAllStudentKendo(reqData): Observable<DataResult> {
    return this.httpClient.post(`${this.apiUrl}/getAllStudent/`, reqData).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  public studentListByClassIdsAndSectionIds(branchId: number, classIds: number[], sectionIds: number[]) {
    let params = {
      branchId: branchId,
      classIds: JSON.stringify(classIds),
      sectionIds: JSON.stringify(sectionIds)
    }
    return this.httpClient.post(`${this.apiUrl}/studentListByClassIdsAndSectionIds/`, params).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  moveStudentToNextClass(student) {
    return this.httpClient.post(`${this.apiUrl}/moveStudentToNextAcademicYear`, student).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  async getStudentById(id: number) {
    return (await this.httpClient.get<GridDataResult>(`${this.apiUrl}/getStudentById/` + id).toPromise()).data;
  }
 
  getStudentCertificateLogById(id) {
    return this.httpClient.get(`${this.apiUrl}/getStudentCertificateLogById/` + id).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  // insertBonafideCertificate(bonafideCertificate) {
  //   return this.httpClient.post(`${this.apiUrl}/insertBonafideCertificate`, bonafideCertificate).pipe(
  //     map((response: any) => {
  //       return response;
  //     })
  //   )
  // }

  public downloadExcelStudent() {
    return this.httpClient.get(`${this.apiUrl}/downloadExcelStudent`, { responseType: 'blob' })
  }
  public downloadStudentCasteWiseReport() {
    return this.httpClient.get(`${this.apiUrl}/downloadStudentCasteWiseReport`, { responseType: 'blob' })
  }
  // Cast category
  addCastCategory(types) {
    return this.httpClient.post(`${this.apiUrl}/manageCasteCategory`, types).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllCastCategory() {
    return this.httpClient.get(`${this.apiUrl}/getAllCasteCategory`).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  getAllCasteCategoryName(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllCasteCategoryName/`).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllCastCategoryKendo(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllCasteCategory/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  /////Religion 
  addReligion(types) {
    return this.httpClient.post(`${this.apiUrl}/manageReligion`, types).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  getAllReligion() {
    return this.httpClient.get(`${this.apiUrl}/getAllReligion`).pipe(
      map((response: any) => {
        return response.data;
      })
    )
  }
  getAllReligionName(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllReligionName/`).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
  public getAllReligionKendo(): Observable<DataResult> {
    return this.httpClient.get(`${this.apiUrl}/getAllReligion/`).pipe(
      map((response: any) => {
        return {
          data: response.data,
          total: response.total
        } as GridDataResult
      })
    ) as any as Observable<GridDataResult>
  }

  sendBirthdayWishes(userIds) {
    return this.httpClient.post(`${this.apiUrl}/sendBirthdayWishes`, { UserIds: userIds }).pipe(
      map((response: any) => {
        return response;
      })
    )
  }

  GetStudentSettings() {
    return this.httpClient.get(`${this.apiUrl}/getStudentSettings`).pipe(
        map((response: any) => {
            return response;
        })
    );
  }

  ManageStudentSettings(data) {
    return this.httpClient.post(`${this.apiUrl}/manageStudentSettings`, data).pipe(
        map((response: any) => {
            return response;
        })
    );
  }
  studentProfileUpdate(data) {    
    return this.httpClient.post(`${this.apiUrl}/studentProfileUpdate`, data).pipe(
      map((response: any) => {
        return response;
      })
    )
  }
}
